import useCheckPermission from "@fartherfinance/frontend/api/Authz/hooks/useCheckPermission";
import { useGetAllAdvisorTransitions } from "@fartherfinance/frontend/api/TransitionWorkflows/hooks/useGetAllAdvisorTransitions";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import { areAllAdvisorTransitionsComplete } from "@src/multiCustodian/pages/Advisor/TransitionWorkflows/utils";

export const useTransitionsNavigation = () => {
  const auth = useAdvisorRequestAuth();
  const { data: transitions = [], isLoading } =
    useGetAllAdvisorTransitions(auth);

  const transitionLeadershipHubResourceCheck = useCheckPermission(
    {
      type: "LeadershipHub",
      action: "view",
      id: "Farther",
    },
    auth
  );

  const canViewTransitionLeadershipHub =
    transitionLeadershipHubResourceCheck.data?.authorized === true;

  const areTransitionsEmpty = transitions.length === 0;
  const areAllTransitionsComplete =
    areAllAdvisorTransitionsComplete(transitions);

  const shouldMoveTransitionsNavToTop = canViewTransitionLeadershipHub
    ? false
    : !areTransitionsEmpty && !areAllTransitionsComplete;

  const firstTransitionId = transitions.at(0)?.transitionId;

  const transitionsLandingPagePath = canViewTransitionLeadershipHub
    ? "/Advisor/Transitions"
    : firstTransitionId
    ? `/Advisor/Transitions/${firstTransitionId}/Summary`
    : undefined;

  return {
    shouldRedirectToTransitionLeadershipHub: canViewTransitionLeadershipHub,
    shouldRedirectToTransitionSummary: !canViewTransitionLeadershipHub,
    shouldMoveTransitionsNavToTop: shouldMoveTransitionsNavToTop,
    firstTransitionId,
    transitionsLandingPagePath,
    isLoading,
  };
};
